import { ResponsiveContainer, AreaChart as RechartsAreaChart, CartesianGrid, XAxis, YAxis, Area, Tooltip } from "recharts";
import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { AreaChartProps } from "../../../interfaces/props/AreaChartProps";
import classes from './AreaChart.module.scss';

const COLORS = {
  stroke: '#078B5C',
  fill: '#00A767'
}

const AreaChart = ({ data, tooltipName }: AreaChartProps) => {
  const domain = useMemo(() => {
    if (data.length > 0) {
      return [0, data[data.length - 1].count];
    }
  }, [data]);

  return <Box className='rounded border p-1' >
    <Typography className={`fs-7 ms-4 my-2 ${classes['label']}`} >
      {data.length > 0 ? `From ${data[0].date} to ${data[data.length - 1].date}` : 'No Data'}
    </Typography>
    <ResponsiveContainer className='chart-box'>
      <RechartsAreaChart
        data={data}
        margin={{
          top: 10,
          right: 15,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis dataKey='date' />
        <YAxis type='number' domain={domain} allowDecimals={false} />
        <Tooltip formatter={(value) => [value, tooltipName]} />
        <Area type='monotone' dataKey='count' stroke={COLORS.stroke} strokeWidth='3px' fill={COLORS.fill} />
      </RechartsAreaChart>
    </ResponsiveContainer>
  </Box>
}

export default AreaChart;
